import React, { useState } from "react";

import {
  CBadge,
  CButton,
  CFormGroup,
  CInput,
  CLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CSelect
} from "@coreui/react";
import ReactDOM from "react-dom";
import {
  getSmoothStepPath,
  getEdgeCenter,
  getMarkerEnd,
  useStoreState
} from "react-flow-renderer";
import { toastr } from "react-redux-toastr";

const foreignObjectSize = 20;

const appRoot = document.getElementById("root");

class ConditionModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      first: props.first,
      second: props.second,
      operator: props.operator
    };

    this.el = document.createElement("div");
  }

  componentDidMount() {
    appRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    appRoot.removeChild(this.el);
  }

  onSave() {
    if (!this.state.first) {
      toastr.warning("Atenção", "Selecione o parâmetro");
      return;
    }

    if (!this.state.operator) {
      toastr.warning("Atenção", "Selecione o operador");
      return;
    }

    if (!this.state.second) {
      toastr.warning("Atenção", "Selecione o valor");
      return;
    }

    this.props.onClose(this.state);
  }

  onClean() {
    this.setState(
      {
        first: null,
        second: null,
        operator: null
      },
      () => {
        this.props.onClose(this.state);
      }
    );
  }

  render() {
    return ReactDOM.createPortal(
      <CModal
        show={this.props.show}
        centered
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
        onClick={e => e.stopPropagation()}
      >
        <CModalHeader closeButton>Condição da aresta</CModalHeader>
        <CModalBody className="d-flex">
          <CFormGroup className="mr-2 mb-0 flex-1">
            <CLabel>Parâmetro</CLabel>
            <CSelect
              value={this.state.first}
              onChange={e => this.setState({ first: e.target.value })}
            >
              <option>Selecione</option>
              <option value="grade">Nota</option>
              <option value="percentage">Percentual</option>
            </CSelect>
          </CFormGroup>
          <CFormGroup className="mr-2 mb-0 flex-1">
            <CLabel>Operador</CLabel>
            <CSelect
              value={this.state.operator}
              onChange={e => this.setState({ operator: e.target.value })}
            >
              <option>Selecione</option>
              <option value="===">Igual a</option>
              <option value=">">Maior que</option>
              <option value=">=">Maior ou igual que</option>
              <option value="<">Menor que</option>
              <option value="<=">Menor ou igual que</option>
            </CSelect>
          </CFormGroup>
          <CFormGroup className="mb-0 flex-1">
            <CLabel>Valor</CLabel>
            <CInput
              placeholder="Digite o valor"
              value={this.state.second}
              onChange={e => this.setState({ second: e.target.value })}
            />
          </CFormGroup>
        </CModalBody>
        <CModalFooter className="justify-content-between">
          <CButton color="danger" onClick={() => this.onClean()}>
            Limpar
          </CButton>
          <div>
            <CButton
              color="primary"
              className="mr-2"
              onClick={() => this.onSave()}
            >
              Confirmar
            </CButton>
            <CButton color="secondary" onClick={() => this.props.onClose()}>
              Cancelar
            </CButton>
          </div>
        </CModalFooter>
      </CModal>,
      this.el
    );
  }
}

const getFirst = first => {
  if (first === "grade") {
    return "Nota";
  }

  return "Percentual";
};

const getOperator = operator => {
  if (operator === "===" || operator === "==") {
    return "=";
  }

  return operator;
};

const getSecond = second => second;

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data = {},
  arrowHeadType,
  markerEndId,
  selected,
  animated,
  ...props
}) {
  const [conditionModal, setConditionModal] = useState(false);
  const edgePath = getSmoothStepPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  });
  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);
  const [edgeCenterX, edgeCenterY] = getEdgeCenter({
    sourceX,
    sourceY,
    targetX,
    targetY
  });
  const selectedElements = useStoreState(store => store.selectedElements);
  const opacity = data.doing && !data.possible ? 0.3 : 1;

  const changeCondition = condition => {
    data.editElement({
      id,
      type: "default",
      data: {
        ...data,
        ...condition
      }
    });

    data.setDrag(true);
    setConditionModal(false);
  };

  return (
    <>
      {conditionModal && (
        <ConditionModal
          show
          operator={data.operator}
          first={data.first}
          second={data.second}
          onClose={changeCondition}
        />
      )}
      <path
        id={id}
        style={{
          ...style,
          opacity,
          transition: "opacity 0.15s ease-in-out"
        }}
        className="react-flow__edge-path"
        d={edgePath}
        markerEnd={`${
          animated ? markerEnd.replace("closed", "closedactive") : markerEnd
        }`}
      />
      {data.editable ? (
        <foreignObject
          width={200}
          height={foreignObjectSize}
          x={edgeCenterX - 200 / 2}
          y={edgeCenterY - foreignObjectSize / 2}
          className="edgebutton-foreignobject"
          requiredExtensions="http://www.w3.org/1999/xhtml"
        >
          <div
            className="w-auto d-flex align-items-center justify-content-center"
            style={{ opacity: Math.min(1, opacity + 0.2) }}
          >
            <CBadge
              color="primary"
              className="px-2 py-1 d-flex align-items-center justify-content-center btn-primary cursor"
              onClick={() => {
                setConditionModal(true);
                data.setDrag(false);
              }}
            >
              {data.first ? (
                <span className="mr-2">
                  {getFirst(data.first)}
                  {` ${getOperator(data.operator)} `}
                  {getSecond(data.second)}
                </span>
              ) : (
                <span className="mr-2" style={{ opacity: 0.5 }}>
                  Nenhuma condição
                </span>
              )}
              <i className="fa fa-gear"></i>
            </CBadge>
          </div>
        </foreignObject>
      ) : data.first ? (
        <foreignObject
          width={200}
          height={200}
          x={edgeCenterX - 200 / 2}
          y={edgeCenterY - foreignObjectSize / 2}
          className="edgebutton-foreignobject"
          requiredExtensions="http://www.w3.org/1999/xhtml"
        >
          <div
            className="w-auto d-flex align-items-center justify-content-center"
            style={{ opacity: Math.min(1, opacity + 0.2) }}
          >
            <CBadge
              color={
                data.doing && data.active
                  ? "primary"
                  : data.doing && data.possible
                  ? "dark"
                  : "secondary"
              }
              className="px-2 py-1 d-flex align-items-center justify-content-center"
            >
              {data.doing && !data.active ? (
                <i className="fa fa-lock mr-2"></i>
              ) : data.doing && data.active ? (
                <i className="fa fa-unlock mr-2"></i>
              ) : null}
              {getFirst(data.first)}
              {` ${getOperator(data.operator)} `}
              {getSecond(data.second)}
            </CBadge>
          </div>
        </foreignObject>
      ) : null}
    </>
  );
}
